import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCompanyStore = defineStore('company', () => {
  const companyFormData = ref({
    // 创建企业的表单
    companyName: '',
    accountType: 'email', // email or phone
    codeId: '',
    code: '',
    employeesMin: 0,
    employeesMax: 0,
    employeeEmail: '',
  })
  const hasPermission = ref(true)
  const userLogo = ref('')
  return {
    companyFormData,
    hasPermission,
    userLogo,
  }
})
